module.exports = __webpack_public_path__ + "assets/img/triple_close_r.05ee321d.svg";